import { render, staticRenderFns } from "./Webforms.vue?vue&type=template&id=a85cee18"
import script from "./Webforms.vue?vue&type=script&lang=js"
export * from "./Webforms.vue?vue&type=script&lang=js"
import style0 from "./Webforms.vue?vue&type=style&index=0&id=a85cee18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports